module.exports = __webpack_public_path__ + "img/7.885eb8b4.jpg";